
import Radio from '@mui/material/Radio';
import styles from './RadioAnswer.module.css';

const RadioAnswer = ({ checked, nextQuestionHandler, value, title, id, lastStepQuestion, handleChange, handelRequiredQuestion }) => {

  return (
    <p
      key={id}
      className={`${styles.options}
      ${checked ? styles.selected : null}
      `}
      onClick={() => { nextQuestionHandler(value); handelRequiredQuestion(false) }}
      style={{ display: "flex", alignItems: "center" }}
    >
      <Radio
        checked={checked}
        checkedIcon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#0FB694" />
          <path d="M9 12L11 14L15 10" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>}
      />
      {title}
    </p>)
}

export default RadioAnswer